import { Component } from '@angular/core';
import {NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'app-hero-abot-us',
  standalone: true,
  imports: [
    NgOptimizedImage
  ],
  templateUrl: './hero-abot-us.component.html',
  styleUrl: './hero-abot-us.component.css'
})
export class HeroAbotUsComponent {

  title = 'Nosotros';
  subtitle1 = 'Somos un equipo humano';
  subtitle2 = 'con una sólida trayectoria en servicios de salud ambulatorios e integrales. Nuestro compromiso es el bienestar de nuestros usuarios, a quienes acompañamos con empatía y dedicación en su camino hacia una vida más saludable.';
  callToAction = '';
  routeImageMain = 'assets/img/aboutUs/nosotros.svg';

}
